import { loc } from '../lib/_location.js';
export let contact = {
	target: null,
	init: function(){
		contact.target = document.querySelector("#contact_form");
		if( contact.target ){
			contact.nav();
			contact.changeType();
			contact.initRecaptcha();
		}
	},
	initRecaptcha: function(){
		// reCAPTCHA のコールバックは window に生やす必要がある
		window.verifyCallback = function(){
			let $btn = document.querySelector(`.c-to_confirm button[type="submit"]`);
			if( $btn ) $btn.removeAttribute("disabled");
		};
		window.expiredCallback = function(){
			let $btn = document.querySelector(`.c-to_confirm button[type="submit"]`);
			if( $btn ) $btn.setAttribute("disabled", true);
		};
	},
	nav: function(){
		let $typeBtns = document.querySelectorAll(`#nav_select_type input[type="radio"]`);
		$typeBtns.forEach( ($btn, index) => {
			$btn.addEventListener("change", contact.changeURL, false);
		});
	},
	changeURL: function(e){
		let val = "";
		if( !e ){
			val = "individual";
		}else{
			val = e.target.value;
		}
		let newURL = location.pathname + "?type=" + val;
		history.replaceState({}, '', newURL);
		contact.changeType();
	},
	changeType: function(e){
		let info = loc.all();
		let params = info.params;
		let val = "individual";
		let typeText = "個人";
		if( params.type ){
			val = params.type;
		}
		let $typeConfirm = document.querySelector("p#contact_type");
		
		//console.log(val);
		contact.target.setAttribute("data-form-type", val);
		
		let $indivisual = document.querySelector("#individual");
		let $corp = document.querySelector("#corporate");
		let activeDiv;
		if( val === "individual" ){
			$corp.querySelectorAll('input, select, textarea').forEach(el => {
			  el.disabled = true;
			});
			$indivisual.querySelectorAll('input, select, textarea').forEach(el => {
			  el.disabled = false;
			});
			activeDiv = $indivisual;
		}else{
			typeText = "法人";
			$corp.querySelectorAll('input, select, textarea').forEach(el => {
			  el.disabled = false;
			});
			$indivisual.querySelectorAll('input, select, textarea').forEach(el => {
			  el.disabled = true;
			});
			activeDiv = $corp;
		}
		// 表示された側のラジオボタンの先頭をcheckedにする
		
		const radioNames = new Set();
	
		activeDiv.querySelectorAll('input[type="radio"]').forEach(r => {
			radioNames.add(r.name);
		});
		
		radioNames.forEach(name => {
			const first = activeDiv.querySelector(`input[type="radio"][name="${name}"]`);
			if (first) first.checked = true;
		});
		
		
		//$typeConfirm.innerHTML = typeText;
	}
}